import { ApiRequestError, getAccessToken } from './api';

/**
 * GET a file and save it to disk.
 *
 * Separate from `api.get` because the response is bytes, not JSON — the school
 * export streams a zip straight out of the request rather than going through
 * stored-file storage first.
 */
export async function getForFile(path: string, fallbackName: string): Promise<void> {
  const response = await fetch(path, {
    credentials: 'include',
    headers: { Authorization: `Bearer ${getAccessToken() ?? ''}` },
  });

  if (!response.ok) {
    let message = 'Could not build that file';
    try {
      const payload = (await response.json()) as { error?: { message?: string; code?: string } };
      if (payload.error) {
        throw new ApiRequestError(
          response.status,
          payload.error.code ?? 'REQUEST_FAILED',
          payload.error.message ?? message,
        );
      }
    } catch (caught) {
      if (caught instanceof ApiRequestError) throw caught;
    }
    throw new Error(message);
  }

  // The server names the file (it knows the school and the date); the fallback
  // only applies if the header did not survive a proxy.
  const disposition = response.headers.get('content-disposition') ?? '';
  const named = /filename="([^"]+)"/.exec(disposition)?.[1];

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = named ?? fallbackName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
